import { Icon } from "@/lib/icons";

export default function Footer({ site }) {
  const f = site?.footer || {};
  const branding = site?.branding || {};
  const go = (href) => {
    if (href?.startsWith("#")) document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer className="bg-[var(--c-primary)] text-[var(--c-bg)] relative overflow-hidden">
      <div className="absolute inset-0 bg-noise opacity-30" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 relative">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div>
            <div className="flex items-center gap-3">
              <span className="grid place-items-center h-11 w-11 rounded-full border border-[var(--c-accent)]">
                <Icon name="Mic" className="h-5 w-5" />
              </span>
              <div>
                <div className="font-heading text-2xl font-bold">{branding.name}</div>
                <div className="font-body text-[10px] tracking-[0.3em] text-[var(--c-accent)]">{branding.sub}</div>
              </div>
            </div>
            <p className="font-body text-sm text-white/70 mt-5 leading-relaxed max-w-sm">{f.about}</p>
            <div className="flex gap-3 mt-6">
              {(f.socials || []).map((so, i) => (
                <a key={i} href={so.href || "#"} className="grid place-items-center h-10 w-10 rounded-full border border-white/20 hover:bg-[var(--c-accent)] hover:border-[var(--c-accent)] transition-colors">
                  <Icon name={so.icon} className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {(f.columns || []).map((col, i) => (
            <div key={i}>
              <h4 className="font-heading text-lg font-semibold text-[var(--c-accent)]">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {(col.links || []).map((l, k) => (
                  <li key={k}>
                    <button onClick={() => go(l.href)} className="font-body text-sm text-white/70 hover:text-white transition-colors">
                      {l.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/15 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-body text-sm text-white/60">{f.copyright}</p>
          <p className="font-body text-sm text-white/40">{branding.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
